import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';


const helper = new JwtHelperService();

@Injectable({
  providedIn: 'root'
})
export class InterceptorsTokenService implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = localStorage.getItem('token') || null;
    let request = req;
    if (token) {
      const tokeninfo = helper.decodeToken(token);
      request = req.clone({
        setHeaders: {
          "authorization": `Bearer ${token}`,
          "userat": tokeninfo?.user?.nombre || '',
        }
      });
    }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // No redirigir desde los propios endpoints de login (evitar bucle)
          const isLoginEndpoint = request.url.includes('/login') || request.url.includes('/loginTrabajador');
          if (!isLoginEndpoint) {
            const msg = error.error?.msg || '';
            if (msg === 'user_not_found') {
              this.router.navigate(['login'], { queryParams: { error: 'user_not_found' }, replaceUrl: true });
            } else if (msg === 'account_disabled') {
              this.router.navigate(['login'], { queryParams: { error: 'account_disabled' }, replaceUrl: true });
            } else {
              this.router.navigate(['login'], { queryParams: { error: 'auth_failed' }, replaceUrl: true });
            }
          }
        }
        return throwError(() => error);
      })
    );
  }
}
